module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_vm._v("Xiaolu Guo")]), _vm._v(" "), _c('p', {
    staticClass: "TTL"
  }, [_vm._v("A Lover’s Discourse")]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/V-1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("Grove Press")])]), _vm._v(" "), _c('p', {
    staticClass: "Copyright"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("New York")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28955af8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97808021495412.vue
// module id = 69
// module chunks = 0